import axios from "axios";
import { forceLogout } from "../contexts/AuthContext";
import { API_URL } from "./apiUrl";

// The panel's own API (inventory-api); its address is in apiUrl.js
const api = axios.create({
  baseURL: API_URL,
});

/* =========================
   REQUEST INTERCEPTOR
========================= */
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("inv_panel_token");

  if (token) {
    config.headers = {
      ...(config.headers || {}),
      Token: token,
    };
  }

  return config;
});

/* =========================
   RESPONSE INTERCEPTOR
========================= */
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const currentPath = window.location.pathname;

    // Only log out if not already on the login page
    if (status === 401 && !currentPath.includes("/login")) {
      forceLogout();
    }

    return Promise.reject(err);
  }
);

export default api;
